import type { ReactNode } from 'react'
import { GripVertical } from 'lucide-react'
import type { RequirementTemplateSection } from '@ispot/shared'
import type { NotesMode } from './types'

interface Props {
  section: RequirementTemplateSection
  isMissing: boolean
  mode: NotesMode
  children: ReactNode
}

const ALWAYS_SHOW_WHEN_EMPTY = new Set(['acceptance_criteria', 'user_story'])

export function SectionFrame({ section, isMissing, mode, children }: Props) {
  // In clean mode, collapse sections that have no content unless they're
  // interactive anchors (AC, user story) that always need to be present.
  if (mode === 'clean' && isMissing && !ALWAYS_SHOW_WHEN_EMPTY.has(section.kind)) {
    return null
  }

  return (
    <section
      className="group relative"
      style={{ paddingTop: 20, paddingBottom: 12 }}
      aria-label={section.name}
    >
      {mode === 'blocks' && (
        <button
          type="button"
          aria-hidden
          tabIndex={-1}
          className="absolute opacity-0 group-hover:opacity-100 transition-opacity"
          style={{
            left: -22, top: 22,
            width: 18, height: 18,
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            color: 'var(--color-fg-faint)', background: 'transparent', border: 0, cursor: 'grab',
          }}
          title="Drag to reorder (coming soon)"
        >
          <GripVertical size={11} />
        </button>
      )}

      <h3
        className="m-0"
        style={{
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
          color: 'var(--color-fg-muted)',
          marginBottom: 10,
        }}
      >
        {section.name}
      </h3>
      <div>{children}</div>
    </section>
  )
}
